module.exports = "<div class=\"form-control\">\n\t<span class=\"tags\">\n\t\t<span *ngFor=\"let tag of tags, let i = index\" class=\"tag\">\n\t\t\t{{dataattr.length ? tag[dataattr] : tag}} \n\t\t\t<button (click)=\"destroyMe(i)\">&times;</button>\n\t\t</span>\n\t</span>\n\t<input (keydown)=\"doCreateTag($event)\" type=\"text\" class=\"invisible-control\" [(ngModel)]=\"model\" [ngbTypeahead]=\"search\">\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/components/chips/chips.component.html
// module id = ../../../../../src/app/components/chips/chips.component.html
// module chunks = main